<template>
  <div>
  <template v-if="showSurveyModal">
    <survey-modal :show-modal="showModal" />
  </template>
  <b-modal :visible="modal" @hide="closeModal" v-b-modal="modalName">
    <template v-if="errorType === ''">
      <div slot="modal-title">
        {{ modifyTitle }}
        <div v-if="hasMultipleItems && currentStep === 1" class="full-allocation-message">
          {{ $t('fullModificationMessage') }}
        </div>
      </div>
    </template>
    <template v-else>
      <div slot="modal-title" class="danger-text">
        {{ modifyTitle }}
      </div>
    </template>
    <b-container fluid v-if="currentStep === 1">
      <b-row class="inputs-row">
        <div class="col-4">
          <b-form-input
            class="modal-input"
            :disabled="hasMultipleItems"
            v-model="count"
            @blur.native="handleModifyCountBlur"
            :state="isModifyCountInvalid ? false : null"
            tabindex="1"
          /> of {{ totalCount }}
        </div>
        <div class="col-8">
          <fieldset :class="isHostTypeAny ? 'typeahead-fieldset' : ''">
            <legend style="z-index: 5;">{{ $t('host') }}</legend>
            <typeahead
              class="modal-input right dropdown"
              :placeholder="hostValuePlaceholder"
              v-model="hostValue"
              :data="dropdownData"
              ref="typeahead"
              @input="handleHostValueChange"
            />
            <p v-if="isHostTypeHostname" v-html="$t('hostnameInfo')" />
            <div v-if="isHostTypeAny" class="disable-typeahead" />
          </fieldset>
        </div>
      </b-row>
      <b-row>
        <div class="col-12" v-if="isModifyCountInvalid">
          <p :class="`invalid-host-value-text ${topMarginClass}`">
            {{ invalidModifyCount }}
          </p>
        </div>
        <div class="col-12" v-if="isHostValueInvalid && hostValue !== ''">
          <p :class="`invalid-host-value-text ${topMarginClass} ${isModifyCountInvalid ? 'no': ''}`">
            {{ $t('invalidHostTypeMessage', { hostType: readableHostType }) }}
          </p>
        </div>
      </b-row>
      <b-row class="text-left">
        <div class="col-sm-12 col-md">
          <fieldset class="form-group">
            <legend>{{ $t('selectReason') }} <span class="required-colour">*</span></legend>
            <div class="select-container">
              <b-select
               v-model="reasonOption"
                :options="reasonOptions"
                @change.native="onReasonSelect"
                required
              />
            </div>
          </fieldset>
          <div v-if="showRenameText">
            <span class="align-left warning-colour"
                  v-html="$t('returnRenameReason', {
                    warningLicenseRehostLink: UrlBuilder.warningLicenseRehostLink
                  })"
                />
          </div>
        </div>
      </b-row>
      <b-row class="text-left pt-3" v-if="showOtherInput">
        <div class="col-sm-12 col-md">
          <fieldset class="form-group">
            <legend>{{ $t('otherReason') }} <span class="required-colour">*</span></legend>
            <div class="select-container">
              <b-input class="other-reason-height" v-model="otherReason" />
            </div>
          </fieldset>
        </div>
      </b-row>
      <b-row class="text-left pt-3">
        <div class="col-sm-12 col-md">
          <input type="checkbox" name="consentCheckbox" v-model="consent" />
          &nbsp;&nbsp;&nbsp;&nbsp;
            <span class="align-left required-colour"
              v-html="$t('eformlegalTextCheck',  {
                endUserLicenseAgreement: UrlBuilder.endUserLicenseAgreement,
                rightToAuditCompliance: UrlBuilder.rightToAuditCompliance
              })"
            />
          </b-form-checkbox>
        </div>
      </b-row>
      <b-row>
      </b-row>
      <b-row :class="`buttons-container ${isHostTypeHostname ? 'top-margin' : '' }`">
        <div class="col-12 text-center">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            :disabled="isStepOneCtaButtonDisabled || !reasonOption || !consent || (!(showOtherInput && otherReason) && showOtherInput)"
            @click="currentStep = 2"
            tabindex="2"
          >
            {{ $t('modifyLicenseFile') }}
          </b-button>
        </div>
        <div class="col-12 text-center">
          <a href="#" class="danger-text" v-b-modal="modalName" @click.stop.prevent="closeModal">
            {{ $t('cancel') }}
          </a>
        </div>
      </b-row>
    </b-container>
   <b-container class="step text-center" fluid v-if="currentStep === 2">
     <b-row>
        <div class="col-12">
          <h5>{{ $t('allocateConfirmation') }}</h5>
          <div
            class="description"
            v-html="allocateConfirmationInfo"
          />
        </div>
      </b-row>
      <b-row class="buttons-container">
        <div class="col-12 text-center">
          <b-button
            class="cta-btn"
            variant="success"
            size="lg"
            @click="createLicenseFiles"
          >
            {{ $t('allocateConfirmationYes') }}
          </b-button>
        </div>
        <div class="col-12 text-center">
          <a href="#" class="danger-text" @click.stop.prevent="goToStepOne">
           {{ $t('allocateConfirmationNo') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step" v-else-if="currentStep === 3">
      <b-row>
        <div class="col-12">
          <h5>{{ $t('allocateConfirmationLoadingHeader') }}</h5>
          <div class="description">{{ $t('allocateConfirmationLoadingInfo') }}</div>
        </div>
      </b-row>
      <b-row>
        <div class="col-12">
          <loading customStyle="padding: 10px;" />
        </div>
      </b-row>
    </b-container>
    <b-container fluid v-else-if="currentStep === 4">
      <b-row>
        <div class="col-12">
          <h5 class="step success-text">{{ $t('modifyDownload') }}</h5>
          <div
            class="step description"
            v-html="$t('modifyDownloadInfo', { hostValue: getHostValues })"
          />
          <span class="align-left"
            v-html="$t('rehostLegalText', {
              endUserLicenseAgreement: UrlBuilder.endUserLicenseAgreement,
              rightToAuditCompliance: UrlBuilder.rightToAuditCompliance
              })"
          />
        </div>
      </b-row>
      <b-row class="buttons-container">
        <div class="col-12 text-center">
          <b-button
            variant="primary"
            class="cta-btn"
            @click="downloadLicenseFiles"
            :disabled="isDownloading"
          >
            {{ $tc('downloadLicenseFiles', 1) }}
            <i v-if="isDownloading" class="fa fa-spinner loading-animation" />
          </b-button>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step" v-else>
      <b-row>
        <div class="col-12">
          <div class="description" v-html="errorDescription" />
        </div>
      </b-row>
      <b-row v-if="errorType === 'data'" class="buttons-container text-center">
        <div class="col-12">
          <b-button
            class="secondary-btn"
            variant="primary"
            size="lg"
            @click="downloadFailedTextFile"
          >
            {{ $t('allocateFailSecondaryButtonText') }}
          </b-button>
        </div>
      </b-row>
    </b-container>
    <div slot="modal-footer" />
  </b-modal>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import download from 'downloadjs'

import Loading from './Loading'
import SurveyModal from './SurveyModal'

export default {
  name: 'ModifyAllocationModal',
  components: {
    typeahead: VueBootstrapTypeahead,
    loading: Loading,
    'survey-modal': SurveyModal
  },
  props: {
    modal: { type: Boolean, required: true },
    toggleModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    allowPartial: { type: Boolean, default: false }
  },
  data () {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      currentStep: 1,
      count: 0,
      totalCount: 0,
      hostValue: '',
      dropdownData: [],
      isHostValueInvalid: false,
      isModifyCountInvalid: false,
      wasDataUpdated: false,
      errorType: '',
      isDownloading: false,
      modalName: 'survey-license-modal',
      showModal: false,
      showOtherInput: false,
      showRenameText: false,
      consent: false,
      otherReason: '',
      reasonOption: '',
      reasonOptions: [
          { value: this.$t('modifyReasonOption1'), text: this.$t('modifyReasonOption1') },
          { value: this.$t('modifyReasonOption2'), text: this.$t('modifyReasonOption2') },
          { value: this.$t('modifyReasonOption3'), text: this.$t('modifyReasonOption3') },
          { value: this.$t('modifyReasonOption4'), text: this.$t('modifyReasonOption4') },
          { value: this.$t('modifyReasonOption5'), text: this.$t('modifyReasonOption5') },
          { value: this.$t('modifyReasonOptionOther'), text: this.$t('modifyReasonOptionOther') }
      ]
    }
  },
  updated () {
    if (this.isHostTypeAny) {
      this.hostValue = 'Any'
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = 'Any'
      }
    }
    if (this.modal && !this.wasDataUpdated) {
      const count = this.selectedLicenses[0].Fulfillments
        .reduce((a, c) => a + (+c.fulfilledQuantity), 0)
      this.count = this.totalCount = count
      this.wasDataUpdated = true
    }
  },
  computed: {
    ...mapGetters(['showSurveyModal']),
    hostType () {
      if (this.selectedLicenses.length > 0) {
        return this.selectedLicenses[0].HostType
      }
      return ''
    },
    getHostValues () {
      const hostValues = []
      this.selectedLicenses[0].Fulfillments.forEach(f => {
        if (!hostValues.includes(f.hostIDValue)) {
          hostValues.push(f.hostIDValue)
        }
      })
      return hostValues.join(', ')
    },
    readableHostType () {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('macAddress')
        case 'Internet':
          return this.$t('ipAddress')
        case 'HostName':
          return this.$t('hostname')
      }
    },
    isHostTypeAny () {
      return this.hostType.toLowerCase() === 'any'
    },
    isHostTypeHostname () {
      return this.hostType.toLowerCase() === 'hostname'
    },
    hostValuePlaceholder () {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('enterMacAddress')
        case 'Internet':
          return this.$t('enterIpAddress')
        case 'HostName':
          return this.$t('enterHostName')
        case 'Any':
          return this.$t('any')
        default:
          return ''
      }
    },
    isHostValueValid () {
      let regEx
      let isValid = false
      switch (this.hostType) {
        case 'Ethernet':
          regEx = /^[0-9a-fA-F]{12}$/
          break
        case 'Internet':
          regEx = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/
          break
        case 'HostName':
          regEx = /^[^~{}[\]<>\s]+$/ // exclude characters ~{}[]<>
          break
        case 'Any':
          // match ethernet or internet or any
          regEx = /(^[0-9a-fA-F]{12}$|\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b|^\S*$)/
          break
        default:
          return false
      }
      isValid = regEx.test(this.hostValue)
      if (isValid) {
        return !this.$store.getters.hasXssKeyWord(this.hostValue)
      }
      return false
    },
    isStepOneCtaButtonDisabled () {
      return this.hostValue === '' ||
        !this.isHostValueValid ||
        this.count > this.totalCount ||
        this.isModifyCountInvalid
    },
    customerId () {
      return this.$store.getters.person.customerId
    },
    loggedInUserName () {
      return this.$store.getters.authToken.userName || ''
    },
    loggedInUserPersonID () {
      return this.$store.getters.authToken.personId || ''
    },
    modifyTitle () {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorTitle')
        case 'system':
          return this.$t('failSystemErrorTitle')
        default:
          return this.$t('modifyAllocations')
      }
    },
    errorDescription () {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          })
        case 'system':
          return this.$t('failSystemErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          })
        default:
          return ''
      }
    },
    failedDownloadText () {
      return `${this.$t('referCustomerCare')}\r\n\r\n` +
        `${this.$t('unableToAllocatePrefix')}\r\n\r\n` +
        `${this.failedModifications.join('\r\n')}\r\n\r\n` +
        `${this.$t('unableToAllocateSuffix')}\r\n\r\n` +
        `${this.$t('contactCitrix')}`
    },
    hasMultipleItems () {
      return this.selectedLicenses[0].Fulfillments.length > 1 || !this.allowPartial
    },
    topMarginClass () {
      return this.isHostTypeHostname ? 'message top-margin' : ''
    },
    allocateConfirmationInfo () {
      return this.$t('allocateConfirmationInfo', {
        remainingCount: this.count,
        hostValue: this.hostValue,
        license: this.count === 1 ? this.$t('license') : this.$tc('licenses', 2)
      })
    },
    invalidModifyCount () {
      if (isNaN(Number(this.count))) {
        return this.$t('invalidAllocateCountNonNumeric')
      } else if (Number(this.count) > Number(this.totalCount)) {
        return this.$t('invalidModifyCountExcessCount', { count: this.totalCount })
      }
      return this.$t('invalidModifyCount')
    },
    downloadRequestBody () {
      return this.succeededModifications.map((l) => ({
        activationID: l.ActivationID,
        customerId: this.customerId,
        hostId: [this.hostType === 'Ethernet' ? `Ethernet=${this.hostValue}` : this.hostValue],
        hostType: this.hostType,
        loggedInUserName: this.loggedInUserName,
        loggedInUserPersonID: this.$store.getters.person.id,
        action: 'Reallocate Download',
        licenseLineItemNumber: l.LicenseItemNumber,
        productName: l.ProductName,
        assetID: l.AssetID
      }))
    }
  },
  methods: {
    onReasonSelect () {
      this.$nextTick(() => {
        this.showOtherInput = (this.reasonOption === this.$t('modifyReasonOptionOther'))
        this.showRenameText = (this.reasonOption === this.$t('modifyReasonOption1') || this.reasonOption === this.$t('modifyReasonOption3'))
      })
    },
    handleModifyCountBlur () {
      const count = Number(this.count)
      this.isModifyCountInvalid = count === 0 ||
        isNaN(count) ||
        count > Number(this.totalCount)
    },
    handleHostValueChange (hostValue) {
      this.isHostValueInvalid = !this.isHostValueValid
      this.$refs.typeahead.inputValue = hostValue.slice(0, 1000)
    },
    createLicenseFiles () {
      this.currentStep = 3
      if (this.totalCount >= this.count) {
        this.bottle
          .post(this.UrlBuilder.modifyUrl, this.selectedLicenses[0].Fulfillments.map((l) => ({
            customerID: this.customerId,
            activationID: this.selectedLicenses[0].ActivationID,
            hostID: encodeURIComponent(this.hostValue),
            hostType: this.hostType,
            quantity: this.hasMultipleItems ? +l.fulfilledQuantity : this.count,
            loggedInUserName: this.loggedInUserName,
            loggedInUserPersonID: this.$store.getters.person.id,
            action: 'ReAllocate',
            assetID: this.selectedLicenses[0].AssetID,
            licenseLineItemNumber: this.selectedLicenses[0].LicenseItemNumber,
            productName: this.selectedLicenses[0].ProductName,
            fulfillmentID: l.fulfillmentID,
            serialNumber: this.selectedLicenses[0].SerialNumber,
            actionReason: this.otherReason ? this.otherReason : this.reasonOption,
            consentBy: this.consent ? this.$store.getters.person.username : ''
          })))
          .then(({ data }) => {
            this.totalCount = this.totalCount - this.count
            this.count = this.totalCount
            Vue.AppInsights.trackEvent('Modify action', {
              customerId: this.customerId,
              data: data.map(d => ({
                hostType: d.hostIDType,
                hostId: d.hostIDValue,
                quantity: d.fulfilledQuantity,
                status: d.status,
                activationID: d.activationID
              }))
            })
            if (data.some(d => d.status === 'FAILURE')) {
              const failedModifications = data
                .filter(d => d.status === 'FAILURE')
                .map(d => d.activationID)
              this.selectedLicenses.forEach((l) => {
                let arr
                if (failedModifications.includes(l.ActivationID)) {
                  arr = [...this.failedModifications]
                  arr.push(l)
                  this.failedModifications = arr.map(l => l.ActivationID)
                }
              })
              this.currentStep = 5
              this.errorType = 'data'
            } else {
              this.currentStep = 4
              this.succeededModifications = [...this.selectedLicenses]
            }
          })
          .catch((error) => {
            this.currentStep = 5
            this.errorType = 'system'
            this.loggly.log({
              errorMessage: 'Failed to modify licenses',
              errorObject: error,
              errorStack: error.stack
            })
          })
      }
    },
    downloadLicenseFiles () {
      this.isDownloading = true
      this.bottle
        .post(
          this.UrlBuilder.getDownloadUrl(),
          this.downloadRequestBody, {
            responseType: 'arraybuffer'
          }
        )
          .then(({ data, headers }) => {
            const fileName = this.getDownloadFilename(headers['content-disposition'])
            Vue.AppInsights.trackEvent('Download action', this.downloadRequestBody)
            this.isDownloading = false
            switch (headers['content-type']) {
              case 'application/zip':
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(
                  new Blob([data], { type: 'application/zip' })
                )
                link.download = fileName
                link.click()
                break
              case 'text/html':
                download(data, fileName, 'text/html')
            }
          })
          .catch((error) => {
            this.isDownloading = false
            this.loggly.log({
              errorMessage: 'License download failed',
              errorObject: error,
              errorStack: error.stack
            })
          })
    },
    closeModal () {
      // reset values before closing modal
      this.showModal = true
      this.currentStep = 1
      this.count = 0
      this.totalCount = 0
      this.hostValue = ''
      this.dropdownData = []
      this.isHostValueInvalid = false
      this.isModifyCountInvalid = false
      this.wasDataUpdated = false
      this.errorType = ''
      this.isDownloading = false
      this.otherReason = ''
      this.showOtherInput = false
      this.showRenameText = false
      this.consent = false
      this.reasonOption = ''
      this.toggleModal()
      this.clearTypeahead()
    },
    getDownloadFilename (string) {
      return string.split('; ')[1].split('=')[1]
    },
    downloadFailedTextFile () {
      download(this.failedDownloadText, 'failed-licenses.txt', 'text/html')
    },
    clearTypeahead () {
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = ''
      }
    },
    goToStepOne () {
      this.currentStep = 1
      this.$nextTick(() => {
        if (this.$refs.typeahead) {
          this.$refs.typeahead.value = this.hostValue
          this.$refs.typeahead.inputValue = this.hostValue
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  button:focus {
    box-shadow: none !important;
    border: none;
    outline: 0;
  }

  a {
    text-decoration: none !important;
  }

  .primary-text {
    color: $primary;
  }

  .success-text {
    color: $success;
  }

  .danger-text {
    color: $danger;
  }

  .modal-input {
    display: inline-block;
    height: 48px;
    width: 80px;
    max-width: 80px;
    margin-top: 12px;
  }
  
  fieldset {
    border: 1px solid $lightGray;
    height: 60px;
    border-radius: 5px;
    padding: 12px 0 0;
    width: 100%;
  }
  
  fieldset > legend {
    padding: 0 10px;
    margin-left: 10px;
    width: auto;
    font-size: 0.75rem;
    color: $darkGray;
    margin-bottom: 0;
    z-index: $legendZIndex;
    position: relative;
    background-color: white;
  }

  .other-reason-height {
    height: 50px;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: white;
    cursor: not-allowed;
  }

  .modal-input.right {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border: none !important;
    position: relative;
    top: -20px;
    margin-top: 0;
  }

  .buttons-container {
    margin-top: 20px;
  }

  .buttons-container.top-margin {
    margin-top: 45px;
  }

  .message.top-margin:not(.no) {
    margin-top: 20px;
  }

  .cta-btn {
    display: inline-block;
    border-radius: 25px;
    margin-bottom: 20px;
  }

  .step {
    text-align: center;
  }

  .align-left {
    text-align: left;
  }

  .step h5 {
    font-size: 26px;
    font-weight: 400;
  }

 .step .description {
    font-size: 18px;
    font-weight: 400;
  }

  .error-border {
    border-color: $danger;
  }

  .invalid-host-value-text {
    color: $danger;
    padding: 10px 0 0;
    margin: 0;
    font-size: 14px;
  }

  .disable-typeahead {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .disable-typeahead:hover {
    cursor: not-allowed;
  }

  .hostname-info {
    position: absolute;
    top:55px;
    bottom: -45px;
  }

  .full-allocation-message {
    color: $darkGray;
    font-size: 16px;
    font-weight: normal;
  }

  .inputs-row {
    padding-bottom: 70px;
  }

  .modal-input {
    display: inline-block;
    height: 48px;
    width: 80px;
    max-width: 80px;
    margin-top: 12px;
  }

  .select-container {
    margin: -20px 0 0;
  }
  select {
    border: none !important;
    height: 30px;
    width: 100% !important;
    text-indent: 10px;
  }
  select {
    font-size: 1rem;
  }
  select:hover,
  select:focus,
  select:active {
    outline: 0 !important;
    border: none !important;
    box-shadow: none !important;
  }
  .required-colour {
    color: red;
  }
  .warning-colour {
    color: #FFCC00;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModifyAllocationModal.vue